const testStoreSaleData = [
    {
        storeId : 1,
        storeName : "대전 관저점",
        createDateTime : "2024-03-25T23:34:07.033865",
        storeFav : false,
        storeAllSaleVol : 1000,
        storeAllSales: 1000000000
    },
    {
        storeId : 2,
        storeName : "대전 마치광장점",
        createDateTime : "2024-03-29T13:57:25.32497",
        storeFav : false,
        storeAllSaleVol : 2000,
        storeAllSales: 4500000000
    },
    {
        storeId : 3,
        storeName : "대전 테스트매장",
        createDateTime : "2024-03-29T14:28:29.907295",
        storeFav : false,
        storeAllSaleVol : 2500,
        storeAllSales: 2500000000
    },
    {
        storeId : 4,
        storeName : "대전 관저점1",
        createDateTime : "2024-03-25T23:34:07.033865",
        storeFav : false,
        storeAllSaleVol : 800,
        storeAllSales: 700000000
    },
    {
        storeId : 5,
        storeName : "대전 마치광장점2",
        createDateTime : "2024-03-29T13:57:25.32497",
        storeFav : false,
        storeAllSaleVol : 750,
        storeAllSales: 800000000
    },
    {
        storeId : 6,
        storeName : "대전 테스트매장3",
        createDateTime : "2024-03-29T14:28:29.907295",
        storeFav : false,
        storeAllSaleVol : 3000,
        storeAllSales: 3300000000
    },
];

export default testStoreSaleData;